import alertConfigurations from './alert-configurations.json';
import configurationRules from './configuration-rules.json';
import whatsNew from './whats-new.json';

const en = {
  ...configurationRules,
  whatsNew,
  'alert-configurations': alertConfigurations,
};

export default en;
